import type { ReactElement, ReactNode } from "react";

import {
    StyledContentWrapper,
    StyledScrollContainer,
    StyledScrollShadowHiderItem,
    StyledScrollShadowItem,
    StyledScrollWrapper,
} from "./styles";

interface IProps {
    height: string;
    children: ReactNode;
}

const ShadowOnScrollWrapper = ({ height, children }: IProps): ReactElement => {
    return (
        <StyledContentWrapper height={height}>
            <StyledScrollWrapper>
                <StyledScrollContainer>
                    {children}

                    <StyledScrollShadowHiderItem />
                </StyledScrollContainer>

                <StyledScrollShadowItem />
            </StyledScrollWrapper>
        </StyledContentWrapper>
    );
};

export default ShadowOnScrollWrapper;
